export default "__VITE_ASSET__Cm_6eJ1J__"